<template>
  <div class="orgRankState vheight">
    <div class="header-seacher">
      <div class="ub">
        <div class="header-firstLine">
          <div class="exportName">
            <span>行政区域：</span>
            <el-select placeholder="请选择" v-model="adminOption" @change="adminSelect" size="mini">
              <el-option
                v-for="(item,index) in adminOptions"
                :key="index"
                :label="item.CantonName"
                :value="item.CantonCode"
              ></el-option>
            </el-select>
          </div>
          <div class="exportName">
            <span>街道办：</span>
            <el-input
              v-model="subdistrictOfficeName"
              size="mini"
              @click.native="opensubdistrictOffice"
              placeholder="请选择"
            ></el-input>
          </div>
          <div class="exportName">
            <span>社区：</span>
            <el-input
              size="mini"
              @click.native="openneighborhoodCommittee"
              placeholder="请选择"
              v-model="neighborhoodCommitteeName"
            ></el-input>
          </div>
          <div class="exportName">
            <span>评价时间：</span>
            <el-select v-model="defSel" placeholder="请选择" size="mini" @change="changeMonth">
              <el-option
                v-for="item in dateOptions"
                :key="item.label"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>

          <div class="searchButton">
            <ps-search @click="search()"></ps-search>
            <ps-clear @click="clear()"></ps-clear>

            <!-- <el-button size="mini" type="primary" class="el-icon-arrow-down" @click="goto">12</el-button> -->
          </div>
        </div>
      </div>
    </div>
    <div class="rank-container" :id="rankId">
      <!-- <div class="score-header ub ub-ac ub-pc">
        近6个月排名倒数的相关机构
      </div>-->
      <div class="score-container">
        <div class="rank-kind" :id="enterpriseId">
          <div class="rank-title">一、物管企业排名情况</div>
          <div class="ub ub-ar" style="flex-wrap:nowrap;">
            <div class="score-kind ub-f1">
              <div class="kind-title ub ub-pc ub-ac">
                评价得分排名
                <span class="mark-front">前10名</span>的物管企业
              </div>
              <div class="kind-content">
                <el-table
                  :data="enterpriseDataTop"
                  stripe
                  key="a"
                  height="100%"
                  @row-dblclick="toPath"
                  header-cell-class-name="header-cell-style"
                >
                  <!-- <el-table-column
                    label="排名"
                    width="50"
                    header-align="center"
                    align="center"
                  >
                    <template slot-scope="scope">
                      {{ scope.$index + 1 }}
                  </template></el-table-column>-->
                  <el-table-column
                    label="排名"
                    width="50"
                    header-align="center"
                    align="center"
                    prop="Rank"
                  ></el-table-column>
                  <!-- <el-table-column
                    label="行政区域"
                    prop="CantonName"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                  ></el-table-column>-->
                  <el-table-column
                    label="物管企业"
                    prop="OrgName"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    label="参与人数"
                    prop="EvaCard"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    label="得分"
                    width="80"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">{{ scope.row.Average | numFixed}}</template>
                  </el-table-column>
                  <el-table-column
                    label="环比"
                    width="50"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.RankChange > 0" class="el-icon-back incre"></span>
                      <span v-if="scope.row.RankChange < 0" class="el-icon-back decre"></span>
                      <span v-if="scope.row.RankChange === 0" class="el-icon-minus equal"></span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div class="score-kind ub-f1">
              <div class="kind-title ub ub-pc ub-ac">
                评价得分排名
                <span class="mark-end">后10名</span>的物管企业
              </div>
              <div class="kind-content">
                <el-table
                  :data="enterpriseDataEnd"
                  stripe
                  height="100%"
                  key="a"
                  header-cell-class-name="header-cell-style"
                >
                  <!-- <el-table-column
                    label="排名"
                    width="50"
                    header-align="center"
                    align="center"
                  >
                    <template slot-scope="scope">
                      {{ scope.$index + 1 }}
                  </template></el-table-column>-->
                  <el-table-column
                    label="排名"
                    width="50"
                    header-align="center"
                    align="center"
                    prop="Rank"
                  ></el-table-column>
                  <!-- <el-table-column
                    label="行政区域"
                    prop="CantonName"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                  ></el-table-column>-->
                  <el-table-column
                    label="物管企业"
                    prop="OrgName"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    label="参与人数"
                    prop="EvaCard"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    label="得分"
                    width="80"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">{{ scope.row.Average | numFixed}}</template>
                  </el-table-column>
                  <el-table-column
                    label="环比"
                    width="50"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.RankChange > 0" class="el-icon-back incre"></span>
                      <span v-if="scope.row.RankChange < 0" class="el-icon-back decre"></span>
                      <span v-if="scope.row.RankChange === 0" class="el-icon-minus equal"></span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div class="ub-f1 score-kind">
              <div class="kind-title ub ub-pc ub-ac">近6个月物管企业平均得分情况</div>
              <div class="kind-content ub ub-ac score-kind-chart">
                <psLine
                  class="chart"
                  :data="enterpriseTrendData"
                  :kind="recentDate"
                  :inverse="true"
                ></psLine>
              </div>
            </div>
          </div>
        </div>
        <div class="rank-kind" :id="orgId">
          <div class="rank-title">二、物管机构排名情况</div>
          <div class="ub ub-ar" style="flex-wrap:nowrap;">
            <div class="score-kind ub-f1">
              <div class="kind-title ub ub-pc ub-ac">
                评价得分排名
                <span class="mark-front">前10名</span>的物管机构
              </div>
              <div class="kind-content">
                <el-table
                  :data="orgDataTop"
                  stripe
                  height="100%"
                  key="a"
                  header-cell-class-name="header-cell-style"
                >
                  <!-- <el-table-column
                    label="排名"
                    width="50"
                    header-align="center"
                    align="center"
                  >
                    <template slot-scope="scope">
                      {{ scope.$index + 1 }}
                  </template></el-table-column>-->
                  <el-table-column
                    label="排名"
                    width="50"
                    header-align="center"
                    align="center"
                    prop="Rank"
                  ></el-table-column>
                  <!-- <el-table-column
                    label="行政区域"
                    prop="CantonName"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                  ></el-table-column>-->
                  <el-table-column
                    label="物管机构"
                    prop="EaAeraName"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    label="参与人数"
                    prop="EvaCard"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    label="得分"
                    width="80"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template
                      slot-scope="scope"
                    >{{ scope.row.TotalScore / scope.row.EvaCard | numFixed}}</template>
                  </el-table-column>
                  <el-table-column
                    label="环比"
                    width="50"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.RankChange > 0" class="el-icon-back incre"></span>
                      <span v-if="scope.row.RankChange < 0" class="el-icon-back decre"></span>
                      <span v-if="scope.row.RankChange === 0" class="el-icon-minus equal"></span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div class="score-kind ub-f1">
              <div class="kind-title ub ub-pc ub-ac">
                评价得分排名
                <span class="mark-end">后10名</span>的物管机构
              </div>
              <div class="kind-content">
                <el-table
                  :data="orgDataEnd"
                  stripe
                  height="100%"
                  key="a"
                  header-cell-class-name="header-cell-style"
                >
                  <!-- <el-table-column
                    label="排名"
                    width="50"
                    header-align="center"
                    align="center"
                  >
                    <template slot-scope="scope">
                      {{ scope.$index + 1 }}
                  </template></el-table-column>-->
                  <el-table-column
                    label="排名"
                    width="50"
                    header-align="center"
                    align="center"
                    prop="Rank"
                  ></el-table-column>
                  <!-- <el-table-column
                    label="行政区域"
                    prop="CantonName"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                  ></el-table-column>-->
                  <el-table-column
                    label="物管机构"
                    prop="EaAeraName"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    label="参与人数"
                    prop="EvaCard"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    label="得分"
                    width="80"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template
                      slot-scope="scope"
                    >{{ scope.row.TotalScore / scope.row.EvaCard | numFixed}}</template>
                  </el-table-column>
                  <el-table-column
                    label="环比"
                    width="50"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.RankChange > 0" class="el-icon-back incre"></span>
                      <span v-if="scope.row.RankChange < 0" class="el-icon-back decre"></span>
                      <span v-if="scope.row.RankChange === 0" class="el-icon-minus equal"></span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div class="ub-f1 score-kind">
              <div class="kind-title ub ub-pc ub-ac">近6个月物管机构平均得分情况</div>
              <div class="kind-content ub ub-ac score-kind-chart">
                <psLine class="chart" :data="orgTrendData" :kind="recentDate" :inverse="true"></psLine>
              </div>
            </div>
          </div>
        </div>
        <div class="rank-kind" :id="committeeId">
          <div class="rank-title">三、业委会排名情况</div>
          <div class="ub ub-ar" style="flex-wrap:nowrap;">
            <div class="score-kind ub-f1">
              <div class="kind-title ub ub-pc ub-ac">
                评价得分排名
                <span class="mark-front">前10名</span>的业委会
              </div>
              <div class="kind-content">
                <el-table
                  :data="committeeDataTop"
                  stripe
                  height="100%"
                  key="a"
                  header-cell-class-name="header-cell-style"
                >
                  <!-- <el-table-column
                    label="排名"
                    width="50"
                    header-align="center"
                    align="center"
                  >
                    <template slot-scope="scope">
                      {{ scope.$index + 1 }}
                  </template></el-table-column>-->
                  <el-table-column
                    label="排名"
                    width="50"
                    header-align="center"
                    align="center"
                    prop="Rank"
                  ></el-table-column>
                  <!-- <el-table-column
                    label="行政区域"
                    prop="CantonName"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                  ></el-table-column>-->
                  <el-table-column
                    label="业委会"
                    prop="OrgName"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    label="参与人数"
                    prop="EvaCard"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    label="得分"
                    width="80"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">{{ scope.row.Average | numFixed}}</template>
                  </el-table-column>
                  <el-table-column
                    label="环比"
                    width="50"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.RankChange > 0" class="el-icon-back incre"></span>
                      <span v-if="scope.row.RankChange < 0" class="el-icon-back decre"></span>
                      <span v-if="scope.row.RankChange === 0" class="el-icon-minus equal"></span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div class="score-kind ub-f1">
              <div class="kind-title ub ub-pc ub-ac">
                评价得分排名
                <span class="mark-end">后10名</span>的业委会
              </div>
              <div class="kind-content">
                <el-table
                  :data="committeeDataEnd"
                  stripe
                  height="100%"
                  key="a"
                  header-cell-class-name="header-cell-style"
                >
                  <!-- <el-table-column
                    label="排名"
                    width="50"
                    header-align="center"
                    align="center"
                  >
                    <template slot-scope="scope">
                      {{ scope.$index + 1 }}
                  </template></el-table-column>-->
                  <el-table-column
                    label="排名"
                    width="50"
                    header-align="center"
                    align="center"
                    prop="Rank"
                  ></el-table-column>
                  <!-- <el-table-column
                    label="行政区域"
                    prop="CantonName"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                  ></el-table-column>-->
                  <el-table-column
                    label="业委会"
                    prop="OrgName"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    label="参与人数"
                    prop="EvaCard"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    label="得分"
                    width="80"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">{{ scope.row.Average | numFixed}}</template>
                  </el-table-column>
                  <el-table-column
                    label="环比"
                    width="50"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.RankChange > 0" class="el-icon-back incre"></span>
                      <span v-if="scope.row.RankChange < 0" class="el-icon-back decre"></span>
                      <span v-if="scope.row.RankChange === 0" class="el-icon-minus equal"></span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div class="ub-f1 score-kind">
              <div class="kind-title ub ub-pc ub-ac">近6个月业委会平均得分情况</div>
              <div class="kind-content ub ub-ac score-kind-chart">
                <psLine class="chart" :data="committeeTrendData" :kind="recentDate" :inverse="true"></psLine>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <subdistrictOffice-comp
      v-if="this.$store.state.subdistrictOffice"
      @propertyVal="subdistrictOfficeUnitproperty"
      @mecQueryHandle="streetOfficeOrgHandle"
      :dataList="subdistrictOfficeData"
    >
      <el-table-column
        prop="OrgCode"
        label="机构代码"
        min-width="150"
        align="left"
        header-align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="OrgName"
        label="街道办名称"
        min-width="200"
        align="left"
        header-align="center"
        show-overflow-tooltip
      ></el-table-column>
    </subdistrictOffice-comp>
    <neighborhoodCommittee-comp
      v-if="this.$store.state.neighborhoodCommittee"
      @propertyVal="neighborhoodCommitteeUnitproperty"
      @mecQueryHandle="residentsCommitteeOrgHandle"
      :dataList="neighborhoodCommitteeData"
    >
      <el-table-column
        prop="OrgCode"
        label="机构代码"
        min-width="150"
        align="left"
        header-align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="OrgName"
        label="居委会名称"
        min-width="200"
        align="left"
        header-align="center"
        show-overflow-tooltip
      ></el-table-column>
    </neighborhoodCommittee-comp>
  </div>
</template>

<script>
import psLine from '@/components/common/line';
import { EvaluteResultController } from '@/service/EvaluteResultController/EvaluteResultController';
import { EvaluateRankResultQueryPara } from '@/service/EvaluteResultController/EvaluateRankResultQueryPara.js';
import { OrganizationBaseSvr } from '@/service/OrganizationBaseSvr.js';
import subdistrictOfficeComp from '@/components/common/subdistrictOfficeComp';
import { StreetOfficeQueryPara } from '@/models/queryparams/StreetOfficeQueryPara';
import { ResidentsCommitteeQueryPara } from '@/models/queryparams/ResidentsCommitteeQueryPara';
import neighborhoodCommitteeComp from '@/components/common/neighborhoodCommitteeComp';
import { CantonMgeSvr } from '@/service/CantonMgeSvr.js';
import { division } from '@/assets/js/division';
import { mapState } from 'vuex';
export default {
  components: {
    psLine,
    subdistrictOfficeComp,
    neighborhoodCommitteeComp
  },
  data() {
    return {
      code: '',
      codeType: 1,
      CantonMgeSvr: new CantonMgeSvr(),
      organizationBaseSvr: new OrganizationBaseSvr(),
      evaluateRankResultQueryPara: new EvaluateRankResultQueryPara(),
      streetOfficeQueryPara: new StreetOfficeQueryPara(), //街道办
      residentsCommitteeQueryPara: new ResidentsCommitteeQueryPara(), //居委会
      showCityManager: false,
      showDistrictManager: false,
      showStreetManager: false,
      showManager: false,
      showCommitteer: false,
      subdistrictOfficeData: [], //街道办单位列表
      neighborhoodCommitteeData: [], //居委会单位列表
      subdistrictOfficeCode: '',
      subdistrictOfficeName: '',
      neighborhoodCommitteeCode: '',
      neighborhoodCommitteeName: '',
      adminOption: '',
      adminOptions: [],
      defSel: '',
      recentDate: [],
      orgTrendData: [],
      committeeTrendData: [],
      enterpriseTrendData: [],
      // isLoading: false,
      date: { year: null, month: null },
      committeeDataTop: [],
      committeeDataEnd: [],
      orgDataTop: [],
      orgDataEnd: [],
      enterpriseDataTop: [],
      enterpriseDataEnd: [],
      dateOptions: []
    };
  },
  computed: {
    ...mapState(['token', 'userInfo']),
    enterpriseId() {
      return 'enterpriseId' + parseInt(Math.random() * 10000);
    },
    orgId() {
      return 'orgId' + parseInt(Math.random() * 10000);
    },
    committeeId() {
      return 'committeeId' + parseInt(Math.random() * 10000);
    },
    rankId() {
      return 'rankId' + parseInt(Math.random() * 10000);
    }
  },
  created() {
    // this.code = this.userInfo.UserParam.CantonCode;
    this.evaluteResultController = new EvaluteResultController();
    //获取行政区域数据
    //获取街道办数据
    //获取社区数据
    this.getMonths();
  },
  mounted() {
    // if (
    //   this.userInfo.UserParam.UserSigns === "物业管理部门领导" ||
    //   this.userInfo.UserParam.UserSigns === "物业管理部门业务主管" ||
    //   this.userInfo.UserParam.UserSigns === "物业管理部门业务经办"
    // ) {
    //   this.showCityManager = true;
    // }
    // if (this.userInfo.UserParam.UserSigns === "区局物业管理部门领导") {
    //   this.showDistrictManager = true;
    // }
    // if (this.userInfo.UserParam.UserSigns === "街道办主任") {
    //   this.showStreetManager = true;
    // }
    // if (this.userInfo.UserParam.UserSigns === "居委会主作,居委会业务经办") {
    //   this.showCommitteer = true;
    // }
    // if (this.userInfo.UserParam.UserSigns === "物业服务企业项目经理") {
    //   this.showCommitteer = true;
    //   this.showManager = true;
    // }
    // if (this.userInfo.UserParam.UserSigns === "业委会主任") {
    //   this.showCommitteer = true;
    // }
    this.CantonMgeSvr.GetCantonList(this.token, division, false).then(res => {
      this.adminOptions = res._Items;
    });
    this.initData();

    if (this.$route.query.to) {
      switch (
        this.$route.query.to // 子元素在父元素内滚动距离为 子元素的相对父类(有定位元素)顶部的距离  + 父类的内边距 - 露出子元素的边框
      ) {
        case 'org':
          this.$el.querySelector('#' + this.rankId).scrollTop =
            this.$el.querySelector('#' + this.orgId).offsetTop + 20 - 1;
          break;
        // case 'enterprise': this.$el.querySelector( '#' + this.rankId).scrollTop = this.$el.querySelector('#'+this.enterpriseId).offsetTop + 20 - 1; break;
        case 'committee':
          this.$el.querySelector('#' + this.rankId).scrollTop =
            this.$el.querySelector('#' + this.committeeId).offsetTop + 20 - 1;
          break;
      }
    }
  },

  methods: {
    toPath(row){
      // this.$router.push('/ownerEvaluationLists');
      this.$router.push({
        path: '/ownerEvaluationLists',
        query: {
          isBoolType: 1,
        }
      });
    },
    search() {
      this.initData();
      this.$emit('getShopCode','false');
    },
    clear() {
      this.code = '';
      this.codeType = 1;
      this.adminOption = '';
      this.subdistrictOfficeName = '';
      this.neighborhoodCommitteeName = '';
      this.initData();
    },
    //打开街道办选择
    opensubdistrictOffice() {
      this.neighborhoodCommitteeName = '';
      /* this.$store.state.subdistrictOffice = true;
      this.streetOfficeOrgHandle(null); */
      if (this.showDistrictManager) {
        this.streetOfficeQueryPara.setParamByCantonCode(
          this.userInfo.UserParam.CantonCode
        );
        this.$store.state.subdistrictOffice = true;
        this.streetOfficeOrgHandle(null);
        return;
      }
      if (this.adminOption != '') {
        this.$store.state.subdistrictOffice = true;
        this.streetOfficeQueryPara.setParamByCantonCode(this.adminOption);
        this.streetOfficeOrgHandle(null);
      } else {
        this.$message({
          message: '请选择行政区域',
          type: 'error'
        });
      }
    },
    //街道办选定事件
    subdistrictOfficeUnitproperty(val) {
      this.code = val.OrgCode;
      this.codeType = 3;
      this.subdistrictOfficeName = val.OrgName;
      this.subdistrictOfficeCode = val.OrgCode;

      //this.propertyAreaDoc.PropertyAreaObj.StreetOfficeOrgCode = val.OrgCode;
    },
    //街道办组件查询事件
    streetOfficeOrgHandle(val) {
      //this.streetOfficeQueryPara = new StreetOfficeQueryPara();
      if (val) {
        if (val.numInp) {
          this.streetOfficeQueryPara.setParamByOrgCode(val.numInp);
        } else {
          this.streetOfficeQueryPara.setParamByOrgCode('');
        }
        if (val.nameInp) {
          this.streetOfficeQueryPara.setParamByOrgName('%' + val.nameInp + '%');
        } else {
          this.streetOfficeQueryPara.setParamByOrgName('%' + '' + '%');
        }
      } else {
        this.streetOfficeQueryPara.setParamByOrgCode('');
        this.streetOfficeQueryPara.setParamByOrgName('%' + '' + '%');
      }

      /* this.streetOfficeQueryPara.setParamByCantonCode(this.adminOption); */
      this.organizationBaseSvr
        .GetStreetOfficeList(
          this.token,
          this.streetOfficeQueryPara,
          0,
          -1,
          false,
          false
        )
        .then(res => {
          this.subdistrictOfficeData = res._Items;
        });
    },
    //打开居委会选择
    openneighborhoodCommittee() {
      if (this.showStreetManager) {
        this.residentsCommitteeQueryPara.setParamByStreetOfficeCode(
          this.userInfo.UserParam.CantonCode
        );
        this.$store.state.neighborhoodCommittee = true;
        this.residentsCommitteeOrgHandle(null);
        return;
      }

      if (this.subdistrictOfficeCode != '') {
        this.residentsCommitteeQueryPara.setParamByStreetOfficeCode(
          this.subdistrictOfficeCode
        );
        this.$store.state.neighborhoodCommittee = true;
        this.residentsCommitteeOrgHandle(null);
        /* this.$nextTick(() => {
          this.$refs.propertyAreaDoc.clearValidate([
            "PropertyAreaObj.ResidentsCommitteeOrgCode"
          ]);
        }); */
      } else {
        this.$message({
          message: '请选择街道办',
          type: 'error'
        });
      }
    },
    //居委会选定事件
    neighborhoodCommitteeUnitproperty(val) {
      this.code = val.OrgCode;
      this.codeType = 4;
      this.neighborhoodCommitteeName = val.OrgName;
      this.neighborhoodCommitteeCode = val.OrgCode;
      /* this.propertyAreaDoc.PropertyAreaObj.ResidentsCommitteeOrgCode =
        val.OrgCode; */
    },
    //居委会组件查询事件
    residentsCommitteeOrgHandle(val) {
      if (val) {
        if (val.numInp) {
          this.residentsCommitteeQueryPara.setParamByOrgCode(val.numInp);
        } else {
          this.residentsCommitteeQueryPara.setParamByOrgCode('');
        }
        if (val.nameInp) {
          this.residentsCommitteeQueryPara.setParamByOrgName(
            '%' + val.nameInp + '%'
          );
        } else {
          this.residentsCommitteeQueryPara.setParamByOrgName('%' + '' + '%');
        }
      } else {
        this.residentsCommitteeQueryPara.setParamByOrgCode('');
        this.residentsCommitteeQueryPara.setParamByOrgName('%' + '' + '%');
      }
      /* if (val != null) {
        this.residentsCommitteeQueryPara.setParamByOrgCode(val.numInp);
        if (val.nameInp) {
          this.residentsCommitteeQueryPara.setParamByOrgName(
            "%" + val.nameInp + "%"
          );
        }
      } */
      /* this.residentsCommitteeQueryPara.setParamByStreetOfficeCode(this.subdistrictOfficeCode); */
      //this.residentsCommitteeQueryPara.setParamByCantonCode(this.adminOption);
      this.organizationBaseSvr
        .GetResidentsCommitteeList(
          this.token,
          this.residentsCommitteeQueryPara,
          0,
          -1,
          false,
          false
        )
        .then(res => {
          this.neighborhoodCommitteeData = res._Items;
        });
    },
    adminSelect() {
      this.evaluateRankResultQueryPara.setParamByCantonCode(this.adminOption);
      this.code = this.adminOption;
      this.codeType = 2;
      this.subdistrictOfficeName = '';
    },
    // 获取近6个月
    getMonths(selDate) {
      this.recentDate = []; // 先重置
      let date = new Date();
      if (selDate) {
        // 如果下拉框选择了日期  则要包含这个月
        date = new Date(selDate);
        date.setMonth(date.getMonth() + 1); // 包含这个月
      }
      // data.setMonth(data.getMonth() + 1, 1); //从当前月份开始倒退,设置月份
      for (var i = 0; i < 6; i++) {
        date.setMonth(date.getMonth() - 1); //每次循环一次 月份值减1
        let m = date.getMonth() + 1;
        // m = m < 10 ? "0" + m : m; // 2019-5 -> 2019-05
        if (i === 0 && !selDate) {
          // 赋值默认选项  及默认date
          this.date.year = date.getFullYear();
          this.date.month = m;
          this.defSel = date.getFullYear() + '-' + m;
        }
        if (!selDate) {
          this.dateOptions.push({
            label: date.getFullYear() + '年' + m + '月',
            value: date.getFullYear() + '-' + m
          });
        }
        this.recentDate.push(m + '月');
      }
    },
    initData() {
      this.toTopTenOrgList();
      this.toEndTenOrgList();
      this.toTopTenCommiteeList();
      this.toEndTenCommiteeList();
      this.getScoreTrend();
      this.toTopTenEaAreaList();
      this.toEndTenEaAreaList();
    },
    // GetTopTenOrgList  获取上月排名前十或后十的机构 (1为物业企业，2为业委会) ( true为正序， false为倒序)
    // 获取物业企业 前10
    toTopTenOrgList() {
      this.evaluteResultController
        .GetTopTenOrgList(
          this.date.year,
          this.date.month,
          1,
          true,
          this.codeType,
          this.code
        )
        .then(res => {
          this.enterpriseDataTop = res._Items;
        });
    },
    // 获取物业企业 后10
    toEndTenOrgList() {
      this.evaluteResultController
        .GetTopTenOrgList(
          this.date.year,
          this.date.month,
          1,
          false,
          this.codeType,
          this.code
        )
        .then(res => {
          this.enterpriseDataEnd = res._Items;
        });
    },
    // 获取业委会 前10
    toTopTenCommiteeList() {
      this.evaluteResultController
        .GetTopTenOrgList(

          this.date.year,
          this.date.month,
          2,
          true,
          this.codeType,
          this.code
        )
        .then(res => {
          this.committeeDataTop = res._Items;
        });
    },
    // 获取业委会 后10
    toEndTenCommiteeList() {
      this.evaluteResultController
        .GetTopTenOrgList(

          this.date.year,
          this.date.month,
          2,
          false,
          this.codeType,
          this.code
        )
        .then(res => {
          this.committeeDataEnd = res._Items;
        });
    },
    // 近6月得分走势
    getScoreTrend() {
      this.evaluteResultController
        .GetScoreTrend(this.token, this.date.year, this.date.month)
        .then(res => {
          this.orgTrendData = res.realtyMgeOrgAvg.reverse();
          this.committeeTrendData = res.ownerTeamAvg.reverse();
          this.enterpriseTrendData = res.realtyMgeComAvg.reverse();
        });
    },
    // 获取物业机构 前10
    toTopTenEaAreaList() {
      this.evaluteResultController
        .GetTopTenEaAreaList(

          this.date.year,
          this.date.month,
          true,
          this.codeType,
          this.code
        )
        .then(res => {
          this.orgDataTop = res._Items;
        });
    },
    // 获取物业机构 后10
    toEndTenEaAreaList() {
      this.evaluteResultController
        .GetTopTenEaAreaList(

          this.date.year,
          this.date.month,
          false,
          this.codeType,
          this.code
        )
        .then(res => {
          this.orgDataEnd = res._Items;
        });
    },
    changeMonth(val) {
      // this.isLoading = true;
      let date = val.split('-');
      this.date.year = date[0];
      this.date.month = date[1];
      this.getMonths(val); // 重新获取传入的月份
      this.initData();
      // setTimeout(() => {
      //   this.isLoading = false;
      // }, 2000);
    }
  }
};
</script>
<style lang="scss">
.orgRankState {
  .header-cell-style {
    background-color: #f7f8fa;
  }
}
</style>
<style lang="scss" scoped>
.orgRankState {
  // padding: 10px 0;
  width: 100%;
  height: 100%;
  // overflow-y: auto;
  .title {
    padding: 20px;
    font-weight: bold;
    font-size: 20px;
  }
  // .score-kind {
  //   padding: 10px 20px;
  //   // width: 500px;
  // }
  .score-kind-chart {
    // height: 400px;
    padding: 10px 20px;
    align-self: stretch;
    .chart {
      height: 400px;
    }
  }
  .rank-container {
    padding: 20px 10px;
    height: calc(100% - 49px);
    overflow-y: auto;
  }
  .rank-kind {
    border: 1px solid #e2e2e2;
    border-top: none;
    padding: 10px 0 0;
    &:nth-child(1) {
      border-top: 1px solid #e2e2e2;
    }
  }
  .incre {
    transform: rotate(90deg);
    color: #7cc562;
  }
  .decre {
    transform: rotate(-90deg);
    color: #ff4546;
  }
  .equal {
    color: #ffb11a;
  }
  .mark-front {
    color: #409eff;
  }
  .mark-end {
    color: #ff494a;
  }
  .score-header {
    height: 66px;
    font-size: 20px;
    font-weight: bold;
    background-color: #ecf5ff;
    border: 1px solid #e2e2e2;
    border-top-right-radius: 6px;
    border-top-left-radius: 6px;
  }
  .score-container {
    // flex-wrap: nowrap;
    position: relative;
    overflow-x: hidden;
    padding: 0;
    .rank-title {
      padding: 10px;
      font-size: 16px;
      font-weight: bold;
    }
  }
  .score-kind {
    // padding: 0 20px;
    border: 1px solid #e2e2e2;
    border-bottom: none;
    &:nth-child(1) {
      border-left: none;
    }
    &:nth-child(3) {
      border-right: none;
    }
    &:nth-child(2) {
      margin: 0 10px;
    }
    .kind-title {
      // font-weight: bold;
      font-size: 16px;
      height: 50px;
      background-color: #f7f8fa;
      border-bottom: 1px solid #e2e2e2;
    }
    .kind-content {
      padding: 20px 10px;
      height: calc(100% - 50px);
    }
  }
}
</style>